import { callNoAuthorizedGraphQLEndpoint } from "module/graphQL";

// Mirrors oppizi-platform's signup uniqueness checks (src/Containers/Auth/SignUp/graphQL.js).
// Same query names + variable shapes so the backend doesn't need any changes.

const IS_EXIST_USER_QUERY = `
  query isExistUserWithEmail($email: String!) {
    isExistUser(email: $email)
  }
`;

export const isExistUserWithEmail = async (email: string): Promise<boolean> => {
  const response = await callNoAuthorizedGraphQLEndpoint(IS_EXIST_USER_QUERY, { email });
  const json = await (response as Response).json();
  return Boolean(json?.data?.isExistUser);
};
